export default __webpack_public_path__ + "static/media/total-amount.d884a4ab.svg";